import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import PricingCard from '../pricing-card';

const PricingCarousel = ({ plans, isYearly, onOpenCheckout, currentSubscriptionDetails, currentSubscriptionLoading }) => {
	const [activeSlide, setActiveSlide] = useState(1);
	return (
		<div className="carousel-container">
			<Swiper
				spaceBetween={16}
				initialSlide={1}
				slidesPerView={'auto'}
				centeredSlides={true}
				pagination={{ clickable: false }}
				modules={[Pagination]}
				onSlideChange={swiper => setActiveSlide(swiper.activeIndex)}
				className="pricing-mobile"
			>
				{plans.map((plan, index) => (
					<SwiperSlide
						key={index}
						className={`h-auto d-flex justify-content-center w-auto mb-4 ${index === activeSlide ? 'active' : 'blurred'}`}
					>
						<PricingCard
							key={plan.id}
							plan={plan}
							isYearly={isYearly}
							isBestValue={index === 1}
							onOpenCheckout={onOpenCheckout}
							currentSubscriptionDetails={currentSubscriptionDetails}
							currentSubscriptionLoading={currentSubscriptionLoading}
						/>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default PricingCarousel;
